// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"condition_wrapper__1Cagm"};